export default "__VITE_ASSET__D_J5bf1s__"